// =====================================================================
// FDI tooth-numbering helpers. Mirrors dos_v2._fdi_are_adjacent on the
// server so client-side validation gives instant UX feedback while
// the server stays the source of truth.
// =====================================================================

export function fdiToArch(fdi) {
  const q = Math.floor(Number(fdi) / 10);
  if (q === 1 || q === 2) return "upper";
  if (q === 3 || q === 4) return "lower";
  return null;
}

// Ordinal position within the arch (0..15).
//   Upper: 18=0, 17=1, ..., 11=7, 21=8, ..., 28=15
//   Lower: 48=0, 47=1, ..., 41=7, 31=8, ..., 38=15
export function fdiToPosition(fdi) {
  const num = Number(fdi);
  if (!num || num < 11 || num > 48) return null;
  const quad = Math.floor(num / 10);
  const unit = num % 10;
  if (![1,2,3,4].includes(quad) || unit < 1 || unit > 8) return null;
  return (quad === 1 || quad === 4) ? (8 - unit) : (7 + unit);
}

// True iff every tooth is in a single contiguous run within the same
// arch. Single tooth / empty array vacuously pass.
export function teethAreAdjacent(teeth) {
  if (!Array.isArray(teeth) || teeth.length <= 1) return true;
  const archs = teeth.map(fdiToArch);
  if (archs.includes(null)) return false;
  if (new Set(archs).size > 1) return false;
  const positions = teeth.map(fdiToPosition);
  if (positions.includes(null)) return false;
  if (new Set(positions).size !== positions.length) return false;
  const sorted = [...positions].sort((a, b) => a - b);
  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i] !== sorted[i-1] + 1) return false;
  }
  return true;
}

// Sort an FDI array by ordinal arch position (left-to-right within arch).
export function sortFdiByPosition(fdis) {
  return [...fdis].sort((a, b) => (fdiToPosition(a) ?? 0) - (fdiToPosition(b) ?? 0));
}
